import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Login from "./login";
import TermsAndConditions from "./TermsAndConditions";
import Registration from "./Registration.js";
import useSignOut from "../components/SignOut";
import { loginRequestCaps } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import "./styles.css";
import * as constants from "../utils/constants.ts";
import { ENVIRONMENTS, getValueByEnv } from "../utils/runtimeEnv";

const MainPage = () => {
  const [savedSerialNumber, setSavedSerialNumber] = useState(-1);
  const [showLogin, setShowLogin] = useState(true);
  const [showTerms, setShowTerms] = useState(false);
  const [showRegisterationMessage, setShowRegistrationMessage] =
    useState(false);
  const [token, setToken] = useState(null);
  const [errorOccurred, setErrorOccurred] = useState(false);
  const { instance, inProgress } = useMsal();
  const [showAuthenticating, setShowAuthenticating] = useState(inProgress !== InteractionStatus.None);
  const [message, setMessage] = useState("");
  const handleSignOut = useSignOut();
  const hasProcessedRedirect = useRef(false);

  const getApiBaseUrl = () => {
    return getValueByEnv({
      [ENVIRONMENTS.LOCAL]: constants.API_ENDPOINT_DEV,
      [ENVIRONMENTS.DEV]: constants.API_ENDPOINT_DEV,
      [ENVIRONMENTS.TEST]: constants.API_ENDPOINT_TEST,
      [ENVIRONMENTS.PROD]: constants.API_ENDPOINT_PROD,
    });
  };

  const reacquireToken = () => {
    setShowAuthenticating(true);
    const request = {
      scopes: ["openid"],
      account: instance.getAllAccounts()[0],
    };

    instance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        setToken(tokenResponse.idToken);
        setShowLogin(false);
        setShowAuthenticating(false);
        setShowTerms(true);
      })
      .catch((error) => {
        console.log("error", error);
        // handle other errors
        setShowAuthenticating(false);
      });
  };

  useEffect(() => {
    if (inProgress !== InteractionStatus.None || hasProcessedRedirect.current) {
      return;
    }

    hasProcessedRedirect.current = true;
    setShowAuthenticating(true);

    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response !== null) {
          window.DD_RUM &&
            window.DD_RUM.setUser({
              id: response.account.idTokenClaims.ProfileID,
            });
          setToken(response.idToken);
          setShowLogin(false);
          setShowAuthenticating(false);
          setShowTerms(true);
        } else if (instance.getAllAccounts()[0]) {
          reacquireToken();
          window.DD_RUM &&
            window.DD_RUM.setUser({
              id: instance.getAllAccounts()[0]?.idTokenClaims?.ProfileID,
            });
        } else {
          setShowAuthenticating(false);
          setShowLogin(true);
          setShowTerms(false);
        }
      })

      .catch((error) => {
        console.log("error", error);
        setShowAuthenticating(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, inProgress]);

  const setTnCAndSerialNumber = async (sn) => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const data = {
      serial_number: sn,
    };
    try {
      const api = getApiBaseUrl();
      const response = await axios.post(api, data, config);
      console.log("Serial Number set successfully:", response.data);
      if (response.status === 200) {
        setMessage(
          "Thank you for registering your product. If you have any questions, please contact 1-833-64POWER."
        );
        setErrorOccurred(false);
      }
    } catch (error) {
      if (error.response?.data?.description === "Token has expired") {
        handleSignOut();
      } else {
        setErrorOccurred(true);
        console.log("Failed to set Serial Number", error);
      }
    }
  };

  const handleSignIn = () => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    setShowAuthenticating(true);
    instance.loginRedirect(loginRequestCaps);
  };

  const handleLogin = () => {
    handleSignIn();
  };

  const handleTermsAccept = (serialNumber) => {
    setShowTerms(false);

    setTnCAndSerialNumber(serialNumber);
    setSavedSerialNumber(serialNumber);
    if (errorOccurred === true) {
      setShowRegistrationMessage(false);
    } else {
      setShowRegistrationMessage(true);
    }
  };
  const handleRetry = () => {
    setTnCAndSerialNumber(savedSerialNumber);
  };

  const handleVerification = () => {
    setShowRegistrationMessage(false);
  };
  return (
    <Box className="main-page-box">
      {showLogin && <Login onLogin={handleLogin} isAuthenticating={showAuthenticating} />}
      {showTerms && <TermsAndConditions onAccept={handleTermsAccept} />}
      {!errorOccurred && showRegisterationMessage && (
        <Registration
          onRetry={handleRetry}
          onSuccess={handleVerification}
          message={message}
        />
      )}

      {errorOccurred && showRegisterationMessage && (
        <div className="retry">
          <div
            style={{
              paddingBottom: "10px",
              fontSize: "20px",
              color: "black",
              fontWeight: "bold",
            }}
          >
            An error occurred. Click below to retry
          </div>
          <div
            style={{
              paddingBottom: "20px",
              fontSize: "14px",
              fontWeight: "normal",
              color: "black",
            }}
          >
            If you continue to get this error, please call the GM Energy
            Customer Support Center at{" "}
            <span style={{ whiteSpace: "nowrap" }}>1-833-64POWER</span>
          </div>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{
              fontSize: "12px",
              backgroundColor: "#000",
              "&:hover": { backgroundColor: "#0009FF" },
            }}
            onClick={handleRetry}
          >
            Retry
          </Button>
        </div>
      )}
    </Box>
  );
};

export default MainPage;
